module.exports = __webpack_public_path__ + "media/images/logo1-9881d1a4ed97502ae1cfba04e788fdd3.png";